import { AnimatePresence, motion } from "framer-motion";
import { Children, useState } from "react";
import styles from "../../style/style.module.css";

const CareerTabs = ({ children, tabs }) => {
  const [activeTab, setActiveTab] = useState(0);
  // converting child to array jo we can aceess the child individually
  const child = Children.toArray(children);

  const animation = {
    hidden: {
      y: 20,
      opacity: 0,
    },
    visible: {
      y: 0,
      opacity: 1,
    },
    exit: {
      y: -20,
      opacity: 0,
    },
  };

  if (child.length === 0) {
    return (
      <div className="flex flex-col items-center gap-5">
        <h1>
          There is no job Available right now! Please send your Resume at :
          careers@vis-group.eu. We will consider your Resume for future
          openings!
        </h1>
      </div>
    );
  }

  return (
    <div className="space-y-16">
      <div className="flex flex-wrap justify-center gap-10">
        {tabs.map((item, index) => {
          return (
            <div
              className="relative px-2"
              onClick={() =>
                setActiveTab((prev) => {
                  return index;
                })
              }
            >
              <h5
                className={`cursor-pointer text-2xl text-visBlue ${activeTab !== index && "hover:text-visOrange"} ${activeTab === index && `${styles.textStroke_visOrange} text-visOrange`}`}
              >
                {item}
              </h5>
              <span
                className={`absolute inset-0 top-[2.3rem] h-[0.1rem] w-full scale-x-0 bg-visOrange transition-all duration-200 ${activeTab === index && "scale-x-100"}`}
              ></span>
            </div>
          );
        })}
      </div>
      <AnimatePresence mode="wait">
        <motion.div
          key={activeTab}
          className="relative w-full"
          variants={animation}
          initial={"hidden"}
          animate={"visible"}
          exit={"exit"}
          transition={{ duration: 0.2 }}
        >
          {child[activeTab]}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default CareerTabs;
